import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { ReuseModal } from "../../ReuseModal";
import React, { useState } from "react";
import { ManageSectionsModals } from "../../../../types/enums";

const optionList = [
  ManageSectionsModals.account_plan,
  ManageSectionsModals.playbook,
];

export const ManageSectionsModal = ({
  setCurrentModalHandler,
  onBack,
  onClose,
  isHide,
}: {
  setCurrentModalHandler: (modal: ManageSectionsModals) => void;
  onBack?: () => void;
  onClose?: () => void;
  isHide?: boolean;
}) => {
  const [option, setOption] = useState<ManageSectionsModals>(optionList[0]);
  const nextStepHandler = () => {
    setCurrentModalHandler(option);
  };

  return (
    <ReuseModal
      isHide={isHide}
      isOpen={true}
      onClose={() => {
        setCurrentModalHandler(ManageSectionsModals.none);
        onClose && onClose();
      }}
      onCancel={() => {
        setCurrentModalHandler(ManageSectionsModals.none);
        onBack && onBack();
      }}
      onSubmit={nextStepHandler}
      title="Manage Sections"
      maxWidth="540px"
      submitBtnText="Next"
      submitBtnColor="#1C3C6C"
    >
      <Stack gap="16px" paddingTop={"8px"}>
        <Stack gap="8px">
          <Typography
            fontWeight={500}
            variant="subtitle1"
            color="custom.textDarkBlue"
          >
            Choose a document to customize
          </Typography>
          <FormControl sx={{ padding: "0 12px", alignItems: "flex-start" }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={option}
              value={option}
              name="radio-buttons-group"
              onChange={(e, el) => setOption(el as ManageSectionsModals)}
            >
              {optionList.map((option) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={<Radio />}
                  label={option}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Stack>
        <Typography component="span" variant="body1" color="text.secondary">
          Selected sections will appear in the generated document for this
          campaign’s contacts.
        </Typography>
      </Stack>
    </ReuseModal>
  );
};
